module.exports = __webpack_public_path__ + "img/correct.afe5ef12.png";